var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.82108 22.1786C8.03543 22.393 8.24962 22.5 8.57117 22.5C8.89254 22.5 9.10689 22.3928 9.32125 22.1786L14.9999 16.5L20.6785 22.1786C20.8929 22.393 21.2142 22.5 21.4286 22.5C21.643 22.5 21.9643 22.3928 22.1787 22.1786C22.6072 21.7501 22.6072 21.1072 22.1787 20.6786L16.5001 15L22.1787 9.32138C22.6072 8.89284 22.6072 8.24994 22.1787 7.8214C21.7501 7.39287 21.1072 7.39287 20.6787 7.8214L15.0001 13.5L9.32144 7.8214C8.8929 7.39287 8.25 7.39287 7.82146 7.8214C7.39293 8.24994 7.39293 8.89284 7.82146 9.32138L13.5001 15L7.82146 20.6786C7.39293 21.1073 7.39293 21.7501 7.82146 22.1788L7.82108 22.1786Z",
    fill: "#B8BDC6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 0.0000610352,
    width: 30,
    height: 30,
    rx: 4,
    fill: "#132441"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModalIcon);
export default __webpack_public_path__ + "static/media/CloseModalIcon.875deb861fcb7036baec173ca627ebce.svg";
export { ForwardRef as ReactComponent };